import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Alert, Box, Button, TextField, Typography } from '@mui/material'
import axios from 'axios'

import { WrappedCard as RegistrationCard } from '../registration/RegistrationCard'
import { EMAIL_REGEX } from '../constants'

const ForgotPassword = () => {
  const [emailAddress, setEmailAddress] = useState('')
  const navigate = useNavigate()
  const [submitError, setSubmitError] = useState(false)
  const [submitSuccess, setSubmitSuccess] = useState(false)

  const handleReset = () => {
    axios
      .post('/api/auth/forgot-password', {
        emailAddress,
      })
      .then(() => {
        setSubmitSuccess(true)
      })
      .catch(() => setSubmitError(true))
  }

  const navigateBackToLogin = () => navigate('/login')

  return (
    <RegistrationCard title={'Forgot Password'}>
      {!submitSuccess && (
        <>
          <Typography>
            Please enter the email address associated with your account
          </Typography>
          <TextField
            fullWidth
            margin={'dense'}
            type='text'
            value={emailAddress}
            placeholder='Enter the account email...'
            onChange={(e) => {
              setEmailAddress(e.target.value)
            }}
            label='Email Address'
          />
        </>
      )}

      {submitError && (
        <Alert severity='error'>
          An error occured. Please try again later.
        </Alert>
      )}

      {submitSuccess && (
        <Alert severity='success'>
          <b>Success!</b> If the email address you entered is associated with an{' '}
          <br /> existing account, a message will appear in your inbox shortly.
        </Alert>
      )}
      <Box sx={{ mt: '16px' }}>
        {submitSuccess && (
          <Button variant={'outlined'} onClick={navigateBackToLogin}>
            Back to Login
          </Button>
        )}
        {!submitSuccess && (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <Button onClick={() => navigate('/login')}>Cancel</Button>
            <Button
              disabled={!emailAddress || !EMAIL_REGEX.test(emailAddress)}
              variant={'contained'}
              onClick={() => handleReset()}
            >
              Send password reset email
            </Button>
          </Box>
        )}
      </Box>
    </RegistrationCard>
  )
}

export default ForgotPassword
